module.exports = __webpack_public_path__ + "static/media/red-diamonds.35170f0b.png";